import React from "react";
import ReactDOM from "react-dom";
import AppResult from "../result/app";
import AppResultList from "../resultList/app";
import App from "../shindan/app";

if (!!document.getElementById("rootShindan")) {
    ReactDOM.render(
        <App
            //@ts-ignore
            isLogin={!!window.isLogin}
            //@ts-ignore
            customerId={window.shopifyParameters.customerId}
        />,
        document.getElementById("rootShindan")
    );
} else if (!!document.getElementById("rootResultList")) {
    ReactDOM.render(
        <AppResultList />,
        document.getElementById("rootResultList")
    );
} else if (!!document.getElementById("rootResult")) {
    ReactDOM.render(<AppResult />, document.getElementById("rootResult"));
}
